// CustomerFormModalContent.jsx
import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { customersApiService } from '../../services';

function CustomerFormModal({ defaultNumber, onClose }) {
  const [values, setValues] = useState({
    customer_number: defaultNumber || '',
    customer_name: '',
    edgemarc: 'no',
    em_mac_address: '',
    wan1: '',
    wan2: '',
    eth: '',
    company_address: '',
    platform: 'broadsoft',
    server: '',
    enterprise: '',
    isp_circuit_id: '',
  });

  const bicomServers = [
    'epbx1.isncom.net',
    'epbx2.isncom.net',
    'epbx3.isncom.net',
    'epbx4.isncom.net',
    'epbx5.isncom.net',
    'epbx6.isncom.net',
    'epbx7.isncom.net',
    'epbx8.isncom.net',
    'epbx9.isncom.net',
    'epbx10.isncom.net',
    'epbx11.isncom.net',
    'epbx12.isncom.net',
    'epbx13.isncom.net',
    'epbx14.isncom.net',
    'jaxhumane.isncom.net',
    'provoice.isncom.net',
  ];

  const handleChange = e => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      await customersApiService.createCustomer(values);
      toast.success('Cliente creado con éxito');
      onClose();
    } catch (error) {
      console.error('Error guardando el cliente:', error);
      alert('Error al guardar el cliente');
    }
  };

  return (
    <div className="w-full h-screen flex justify-center items-start pt-10 overflow-auto">
      <div className="w-full max-w-4xl bg-greenDispatch p-6 shadow-md rounded-md overflow-y-auto max-h-[90vh]">
        <form onSubmit={handleSubmit}>
          {/* Customer Number */}
          <div className="mb-4">
            <label
              htmlFor="customer_number"
              className="block text-gray-700 font-medium"
            >
              Customer Number
            </label>
            <input
              id="customer_number"
              type="text"
              name="customer_number"
              value={values.customer_number}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md shadow-sm"
              placeholder="100XXXXX"
              required
            />
          </div>

          {/* Customer Name */}
          <div className="mb-4">
            <label
              htmlFor="customer_name"
              className="block text-gray-700 font-medium"
            >
              Customer Name
            </label>
            <input
              id="customer_name"
              type="text"
              name="customer_name"
              value={values.customer_name}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md shadow-sm"
              placeholder="Customer company name"
              required
            />
          </div>

          {/* Edgemarc */}
          <div className="mb-4">
            <label
              htmlFor="edgemarc"
              className="block text-gray-700 font-medium"
            >
              Edgemarc
            </label>
            <select
              id="edgemarc"
              name="edgemarc"
              value={values.edgemarc}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md shadow-sm"
            >
              <option value="no">No</option>
              <option value="yes">Yes</option>
            </select>
          </div>

          {values.edgemarc === 'yes' && (
            <div className="mb-4 p-4 bg-lime-500 rounded-md">
              <h3 className="text-lg font-semibold mb-2">Edgemarc Details</h3>
              <input
                type="text"
                name="em_mac_address"
                value={values.em_mac_address}
                onChange={handleChange}
                placeholder="Edgemarc MAC Address"
                className="w-full px-3 py-2 border rounded-md shadow-sm mb-2"
              />
              <input
                type="text"
                name="wan1"
                value={values.wan1}
                onChange={handleChange}
                placeholder="WAN 1 - IP Address"
                className="w-full px-3 py-2 border rounded-md shadow-sm mb-2"
              />
              <input
                type="text"
                name="wan2"
                value={values.wan2}
                onChange={handleChange}
                placeholder="WAN 2 - IP Address"
                className="w-full px-3 py-2 border rounded-md shadow-sm mb-2"
              />
              <input
                type="text"
                name="eth"
                value={values.eth}
                onChange={handleChange}
                placeholder="ETH"
                className="w-full px-3 py-2 border rounded-md shadow-sm"
              />
            </div>
          )}

          {/* Company Address */}
          <div className="mb-4">
            <label
              htmlFor="company_address"
              className="block text-gray-700 font-medium"
            >
              Company Address
            </label>
            <input
              id="company_address"
              type="text"
              name="company_address"
              value={values.company_address}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md shadow-sm"
              placeholder="1234 Main St, City, Country"
              required
            />
          </div>

          {/* Platform */}
          <div className="mb-4">
            <label
              htmlFor="platform"
              className="block text-gray-700 font-medium"
            >
              Platform
            </label>
            <select
              id="platform"
              name="platform"
              value={values.platform}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md shadow-sm"
            >
              <option value="broadsoft">Broadsoft</option>
              <option value="bicom">Bicom</option>
            </select>
          </div>

          {/* Platform Details */}
          {values.platform === 'bicom' && (
            <div className="mb-4">
              <label
                htmlFor="server"
                className="block text-gray-700 font-medium"
              >
                Server
              </label>
              <select
                id="server"
                name="server"
                value={values.server}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-md shadow-sm"
                required
              >
                <option value="">Select a Server</option>
                {bicomServers.map((server, index) => (
                  <option key={index} value={server}>
                    {server}
                  </option>
                ))}
              </select>
            </div>
          )}

          {values.platform === 'broadsoft' && (
            <div className="mb-4">
              <label
                htmlFor="enterprise"
                className="block text-gray-700 font-medium"
              >
                Enterprise
              </label>
              <input
                id="enterprise"
                type="text"
                name="enterprise"
                value={values.enterprise}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-md shadow-sm"
                placeholder="Broadsoft Enterprise"
                required
              />
            </div>
          )}

          {/* ISP - Circuit ID */}
          <div className="mb-4">
            <label
              htmlFor="isp_circuit_id"
              className="block text-gray-700 font-medium"
            >
              ISP - Circuit ID
            </label>
            <input
              id="isp_circuit_id"
              type="text"
              name="isp_circuit_id"
              value={values.isp_circuit_id}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md shadow-sm"
              placeholder="ISP Circuit ID"
              required
            />
          </div>

          {/* Submit Button */}
          <div className="flex justify-end">
            <button
              type="submit"
              className="px-12 py-2 bg-green-600 text-white font-semibold border-b-4 rounded hover:bg-green-500 border-green-800 hover:border-green-700 flex items-center"
            >
              Add Customer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CustomerFormModal;
